import * as THREE from 'three';
import { getLocalTransform } from '../modules/scene';

const Transform = {
  schema: {
    translation: { label: 'Translation', type: 'Vec3', step: 0.1, defaultValue: { x: 0, y: 0, z: 0 }, animatable: true },
    rotation: { label: 'Rotation', type: 'Vec3', step: 1.0, defaultValue: { x: 0, y: 0, z: 0 }, animatable: true },
    scale: { label: 'Scale', type: 'Vec3', step: 0.01, defaultValue: { x: 1, y: 1, z: 1 }, animatable: true }, // Scale's step must be 0.01 as 1 percent
    shear: { label: 'Shear', type: 'Vec3', step: 0.1, defaultValue: { x: 0, y: 0, z: 0 }, animatable: true },
    rotateOrder: { label: 'Rotate Order', type: 'Options', display: 'Dropdown',
      values: ['XYZ', 'YZX', 'ZXY', 'XZY', 'YXZ', 'ZYX'], defaultValue: 'ZYX', },
    preRotation: { label: 'Pre-Rotation', type: 'Vec3', step: 1.0, defaultValue: { x: 0, y: 0, z: 0 } },
    rotatePivotOffset: { label: 'Rotate Pivot Offset', type: 'Vec3', step: 0.1, defaultValue: { x: 0, y: 0, z: 0 } },
    scalePivotOffset: { label: 'Scale Pivot Offset', type: 'Vec3', step: 0.1, defaultValue: { x: 0, y: 0, z: 0 } },
    localRotatePivot: { label: 'Local Rotate Pivot', type: 'Vec3', step: 0.1, defaultValue: { x: 0, y: 0, z: 0 } },
    localScalePivot: { label: 'Local Scale Pivot', type: 'Vec3', step: 0.1, defaultValue: { x: 0, y: 0, z: 0 } },
  },

  update: function (operator, primitive) {
    primitive.transform = getLocalTransform(operator);
  },
};

const LookAt = {
  schema: {
    target: { label: 'LookAt Target', type: 'Plug', plug: 'Transform' },
    orientation: { label: 'Orientation', type: 'Vec3', defaultValue: { x: 0, y: 0, z: 0 }, animatable: true },

    lookAtAxis: { label: 'Look Axis', type: 'Options', display: 'Dropdown', defaultValue: 'Z',
      labels: ['X', 'Y', 'Z'], values: ['X', 'Y', 'Z'], },
    flipLookAtAxis: { label: 'Flip Look Axis', type: 'Boolean', defaultValue: true },

    upAxis: { label: 'Up Axis', type: 'Options', display: 'Dropdown', defaultValue: 'Y',
      labels: ['X', 'Y', 'Z'], values: ['X', 'Y', 'Z'], },
    flipUpAxis: { label: 'Flip Up Axis', type: 'Boolean', defaultValue: false },
  },
};

const BoneTransform = {
  schema: {
    translation: { label: 'Translation', type: 'Vec3', step: 0.1, defaultValue: { x: 0, y: 0, z: 0 }, animatable: true },
    rotation: { label: 'Rotation', type: 'Vec3', step: 1.0, defaultValue: { x: 0, y: 0, z: 0 }, animatable: true },
    scale: { label: 'Scale', type: 'Vec3', step: 0.1, defaultValue: { x: 1, y: 1, z: 1 }, animatable: true },
    rotateOrder: { label: 'Rotate Order', type: 'Options', display: 'Dropdown',
      values: ['XYZ', 'YZX', 'ZXY', 'XZY', 'YXZ', 'ZYX'], defaultValue: 'ZYX', },
    preRotation: { label: 'Pre-Rotation', type: 'Vec3', step: 1.0, defaultValue: { x: 0, y: 0, z: 0 } }, // hidden: true
    rotateAxis: { label: 'Rotate Axis', type: 'Vec3', step: 1.0, defaultValue: { x: 0, y: 0, z: 0 } },
  },

  update: function (operator, primitive, { node }) {
    const { translation, rotation, scale, rotateOrder, preRotation, rotateAxis } = operator;
    if (scale.x === 0) scale.x = 0.0000001;
    if (scale.y === 0) scale.y = 0.0000001;
    if (scale.z === 0) scale.z = 0.0000001;

    const translationM = new THREE.Matrix4().makeTranslation(translation.x, translation.y, translation.z);
    const rotationRadians = new THREE.Vector3().copy(rotation).multiplyScalar(Math.PI / 180);
    const rotationM = new THREE.Matrix4().makeRotationFromEuler(new THREE.Euler(rotationRadians.x, rotationRadians.y, rotationRadians.z, 'ZYX'));
    const shearM = new THREE.Matrix4();
    const scaleM = new THREE.Matrix4().makeScale(scale.x, scale.y, scale.z);

    const preRotationRadians = new THREE.Vector3().copy(preRotation).multiplyScalar(Math.PI / 180);
    const lPreRotationM = new THREE.Matrix4().makeRotationFromEuler(new THREE.Euler(preRotationRadians.x, preRotationRadians.y, preRotationRadians.z, 'ZYX'));

    const rotateAxisRadians  = new THREE.Vector3().copy(rotateAxis).multiplyScalar(Math.PI / 180);
    const lPostRotationM = new THREE.Matrix4().makeRotationFromEuler(new THREE.Euler(rotateAxisRadians.x, rotateAxisRadians.y, rotateAxisRadians.z, 'ZYX'));

    primitive.transform = new THREE.Matrix4().multiply(translationM).multiply(lPreRotationM).multiply(rotationM).multiply(lPostRotationM).multiply(scaleM);
  },

};

export default { Transform, BoneTransform, LookAt };




// WEBPACK FOOTER //
// ./src/operators/Transform.js